/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { CTitle } from '../../components/Widget';
import arrow from '../../../../../../assets/cybersecurity2026/finger.gif';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import link1 from '../../../../../../assets/cybersecurity2026/topic1000/link1.png';
import lastImg from '../../../../../../assets/cybersecurity2026/topic1000/last_img.png';

import { Modal } from 'antd';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
    factorPlay: 1,
    isFactorPlayed: false,
  });
  const linkMap: Record<string, string> = {
    '1': link1
  };
  const [open, setOpen] = useState<boolean>(false);
  const [linkPic, setLinkPic] = useState<string>();

  // 沟通
  const [isCommunication, setCommunication] = React.useState(false);
  // 使用对象来分别跟踪每个tab的已点击链接
  const [clickedLinks, setClickedLinks] = useState<any>(
    {
      A: new Set()
    }
  );
  const [activeTab, setActiveTab] = useState<any>('A');

  // 显示图片模态框
  const showPicFn = (item: any) => {
    setOpen(true);
    setLinkPic(linkMap[item.link || '']);
    // 记录当前tab已点击的链接
    if (item.link) {
      setClickedLinks((prev: any) => ({
        ...prev,
        [activeTab]: new Set(prev[activeTab]).add(item.link!),
      }));
    }
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1000-section1-2'
    );
  };
  // 渲染内容列表
  const renderContentList = (contentList: any[]) => (
    <div className="content-list">
      {contentList?.map((item, index) => (
        <div key={item.id + index} className="content-item">
          <div>
            {item.text}
            {item.link && (
              <>
                <span className="content-pic" onClick={() => showPicFn(item)}>
                  {paragraphsSettings.clickToViewImage}
                </span>
                {/* 只有未点击过的链接才显示箭头 */}
                {!clickedLinks[activeTab].has(item.link) && (
                  <span className="content-arrow"></span>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
  const startCommunication = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    updateComponentState(p_course, p_topic, ID, 'cybersecurity2026-topic1000-section1-1');
    setCommunication(true);
    next += 1;
    setState({ ...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 4) {
      setTimeout(() => startCommunication(next), 1000);
    }
  };

  return (
    <div className="topic-section-1 topic-section-1-en">
      <CTitle title={paragraphsSettings?.title} />
      <div className="tool-content" id="cybersecurity2026-topic1000-section1-1">
        <div
          className="tool-tips"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.l1,
          }}
        />
        {!isCommunication && <img className="arrow" src={arrow} alt="" />}
        <div className="tool-practice tool-orange">
          <span /> <div>{paragraphsSettings.l1LeftListDesc}</div>
        </div>
        {paragraphsSettings.l1LeftList?.map((item: string, i: number) => (
          <div
            key={i}
            className={`tool-item tool-item-${i + 1}  ${
              state.factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            onClick={i === 0 ? () => startCommunication() : undefined} // 点击第一个项目触发动画
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
      <div className="tabs-content">
        <div className="tabs-style" id="cybersecurity2026-topic1000-section1-2">
          <h3>{paragraphsSettings?.tabTitle}</h3>
          <div className="tab-a-title">{paragraphsSettings?.l2}</div>
          <div className="tab-a-content">
            <div className="tab-a-content-left"></div>
            <div className="tab-a-content-right">
              {renderContentList(paragraphsSettings?.caseContent)}
            </div>
          </div>
          <h3 className="date-title">{paragraphsSettings?.l3}</h3>
          <h3>{paragraphsSettings?.l4}</h3>
          <div className="date-bg">
            {paragraphsSettings?.dateList?.map((item: any, i: number) => (
              <div className="date-item" key={i}>
                <span className="date-item-code">{item.code}</span>
                <span className="date-item-text">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="last-box">
          <img className="last-box-img" src={lastImg} alt="" />
        </div>
      </div>
      <Modal
        title={''}
        width={'80%'}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <img src={linkPic} alt="" />
      </Modal>
    </div>
  );
};

export default Section1;
